import React, { useEffect } from "react"
import {
  SelectChangeEvent,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Checkbox,
  Box,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  getCategoryList,
  getSubCategoryList,
  getSubCategoryList1,
  selectTransactions,
  setFilters,
} from "../../slices/transactionsSlice"
import {
  MarkedStatus,
  EntityType,
  entityTypeLabels,
  allowedCategorisationRoles,
} from "../../constants/data"
import { RefreshRounded } from "@mui/icons-material"
import {
  PrimaryButton,
  StyledButton,
  StyledFormControl,
  StyledTextField,
} from "./styles"
import { selectLogin } from "../../slices/loginSlice"
interface TransactionsFiltersProps {
  resetFilterHandler: () => void
  ApplyFilterHandler: () => void
}

const TransactionsFilters: React.FC<TransactionsFiltersProps> = ({
  resetFilterHandler,
  ApplyFilterHandler,
}) => {
  const {
    filters,
    isBankListLoading,
    bankList,
    paymentMethods,
    isPaymentMethodsLoading,
    categoryList,
    subCategoryList,
    subCategoryList1,
  } = useAppSelector(selectTransactions)
  const { role } = useAppSelector(selectLogin)
  const dispatch = useAppDispatch()

  useEffect(() => {
    allowedCategorisationRoles.includes(role) && dispatch(getCategoryList({}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    filters.category &&
      dispatch(getSubCategoryList({ level1: filters.category }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.category])

  useEffect(() => {
    filters.subCategory &&
      dispatch(
        getSubCategoryList1({
          level1: filters.category,
          level2: filters.subCategory,
        }),
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.subCategory])

  const handleCategoryChange = (e: SelectChangeEvent) => {
    dispatch(
      setFilters({
        ...filters,
        category: e.target.value as string,
        subCategory: "",
        subCategory1: "",
      }),
    )
    // dispatch(ClearFilterSubCategory())
  }
  const handleSubCategoryChange = (e: SelectChangeEvent) => {
    dispatch(
      setFilters({
        ...filters,
        subCategory: e.target.value as string,
        subCategory1: "",
      }),
    )
  }
  const handleSubCategory1Change = (e: SelectChangeEvent) => {
    dispatch(
      setFilters({
        ...filters,
        subCategory1: e.target.value as string,
      }),
    )
  }

  const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    // Prevent the default scroll behavior when the mouse wheel is used over the input
    event.preventDefault()
  }

  const handleContactChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setFilters({
        ...filters,
        contact: event.target.value,
      }),
    )
  }

  const handleSelfTransferChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setFilters({
        ...filters,
        removeSelfTransfer: e.target.checked,
      }),
    )
  }

  return (
    <Stack direction="column" gap={2}>
      <StyledFormControl size="small">
        <InputLabel id="select-entity-type">Entity</InputLabel>
        <Select
          labelId="select-entity-type"
          id="selectEntityType"
          label="Type"
          value={filters.entityType}
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                entityType: e.target.value as string,
              }),
            )
          }
        >
          <MenuItem value="all">All</MenuItem>
          {Object.values(EntityType).map((type) => (
            <MenuItem key={type} value={type}>
              {entityTypeLabels[type]}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
      <StyledFormControl size="small">
        <InputLabel id="select-accounts">Account</InputLabel>
        <Select
          labelId="select-accounts"
          id="selectAccounts"
          label="Account"
          multiple
          value={filters.accountId || []}
          onChange={(e: SelectChangeEvent<string[]>) =>
            dispatch(
              setFilters({
                ...filters,
                accountId:
                  typeof e.target.value === "string"
                    ? [e.target.value]
                    : e.target.value,
              }),
            )
          }
          renderValue={(selected) => {
            const selectedAccounts = bankList?.filter((option) =>
              selected.includes(option.id),
            )
            return selectedAccounts
              .map((account) => account.accountName)
              .join(", ")
          }}
          disabled={isBankListLoading}
        >
          {isBankListLoading ? (
            <MenuItem value="">Loading...</MenuItem>
          ) : (
            bankList?.map((bank) => (
              <MenuItem key={bank.id} value={bank.id}>
                <Checkbox
                  checked={
                    filters.accountId && filters.accountId.includes(bank.id)
                  }
                />
                {bank.accountName}
              </MenuItem>
            ))
          )}
        </Select>
      </StyledFormControl>
      <StyledFormControl
        size="small"
        sx={{
          minWidth: "120px",
        }}
      >
        <InputLabel id="payment-method-select">Payment Method</InputLabel>
        <Select
          labelId="payment-method-select"
          id="paymentMethodSelect"
          value={filters.paymentMethod}
          label="Payment Method"
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                paymentMethod: e.target.value as string,
              }),
            )
          }
          disabled={isPaymentMethodsLoading}
        >
          <MenuItem value="all">All</MenuItem>
          {paymentMethods.map((method) => (
            <MenuItem value={method.key}>{method.value}</MenuItem>
          ))}
        </Select>
      </StyledFormControl>
      <StyledFormControl size="small">
        <InputLabel id="marked-status-select">Status</InputLabel>
        <Select
          labelId="marked-status-select"
          id="isMarked"
          value={filters.isMarked}
          label="Status"
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                isMarked: e.target.value as string,
              }),
            )
          }
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value={MarkedStatus.MARKED}>Marked</MenuItem>
          <MenuItem value={MarkedStatus.UNMARKED}>Unmarked</MenuItem>
          <MenuItem value={MarkedStatus.PENDING}>Pending</MenuItem>
        </Select>
      </StyledFormControl>
      <StyledFormControl>
        <FormLabel>Contact</FormLabel>
        <RadioGroup
          aria-labelledby="contact-radio-buttons-group-label"
          defaultValue="none"
          value={filters.contact}
          name="radio-buttons-group"
          onChange={handleContactChange}
        >
          <FormControlLabel
            value={true}
            control={<Radio />}
            label="With Contact"
          />
          <FormControlLabel
            value={false}
            control={<Radio />}
            label="Without Contact"
          />
          <FormControlLabel value="none" control={<Radio />} label="None" />
        </RadioGroup>
      </StyledFormControl>
      <InputLabel>Amount Range</InputLabel>
      <StyledFormControl size="small">
        <StyledTextField
          size="small"
          variant="outlined"
          label="min"
          type="tel"
          value={filters.minAmount}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, "")
            dispatch(setFilters({ ...filters, minAmount: value }))
          }}
        />
      </StyledFormControl>
      <StyledFormControl size="small">
        <StyledTextField
          size="small"
          variant="outlined"
          label="max"
          type="tel"
          value={filters.maxAmount}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, "")
            dispatch(setFilters({ ...filters, maxAmount: value }))
          }}
          onWheel={handleWheel}
        />
      </StyledFormControl>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            onChange={handleSelfTransferChange}
            checked={filters.removeSelfTransfer}
          />
        }
        label="Remove Self Transfer"
        labelPlacement="end"
      />
      {allowedCategorisationRoles.includes(role) && (
        <>
          <StyledFormControl size="small">
            <InputLabel id="select-opertator">Category</InputLabel>
            <Select
              labelId="select-opertator"
              id="selectOperator"
              label="Operator"
              value={filters.category}
              onChange={handleCategoryChange}
            >
              {categoryList.length > 0 ? (
                categoryList.map((category) => (
                  <MenuItem value={category?.id}>{category?.value}</MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No options available
                </MenuItem>
              )}
            </Select>
          </StyledFormControl>
          <StyledFormControl size="small">
            <InputLabel id="select-opertator">Sub-Cat</InputLabel>
            <Select
              labelId="select-opertator"
              id="selectOperator"
              label="Operator"
              value={filters.subCategory}
              onChange={handleSubCategoryChange}
              disabled={!filters.category}
            >
              {subCategoryList.length > 0 ? (
                subCategoryList.map((category) => (
                  <MenuItem value={category?.id}>{category?.value}</MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No options available
                </MenuItem>
              )}
            </Select>
          </StyledFormControl>
          <StyledFormControl size="small">
            <InputLabel id="select-opertator">Sub-Cat-2</InputLabel>
            <Select
              labelId="select-opertator"
              id="selectOperator"
              label="Operator"
              value={filters.subCategory1}
              onChange={handleSubCategory1Change}
              disabled={!filters.subCategory}
            >
              {subCategoryList1.length > 0 ? (
                subCategoryList1.map((category) => (
                  <MenuItem value={category?.id}>{category?.value}</MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No options available
                </MenuItem>
              )}
            </Select>
          </StyledFormControl>
        </>
      )}
      <Box sx={{ display: "flex", gap: "10px", flex: 1 }}>
        <StyledButton
          sx={{ width: "100%" }}
          variant="outlined"
          startIcon={<RefreshRounded fontSize="small" />}
          color="inherit"
          onClick={resetFilterHandler}
        >
          Reset
        </StyledButton>
        <PrimaryButton
          sx={{ width: "100%" }}
          variant="contained"
          onClick={ApplyFilterHandler}
        >
          Apply
        </PrimaryButton>
      </Box>
    </Stack>
  )
}

export default TransactionsFilters
